import Blue from "~/core";

function handleIntersect(entries) {
			entries.forEach(entry => {
				entry.target.setAttribute('data-visible', entry.intersectionRatio)
			})
}
const observer = new IntersectionObserver(handleIntersect, {threshold: [0, 0.7, 1]});

new Blue ({
	name: 'Leadership Grid',
	selector: '.leadership__person-container',
	setup(trigger) {
		const grid = trigger.closest(".leadership__grid");
		const cell = trigger.closest(".leadership__grid-cell");
		const cellArr = [...grid.querySelectorAll(".leadership__grid-cell")];
		const detail = cell.querySelector('.leadership__detail-container');
		const closeBtn = cell.querySelector(".leadership__detail-close-link");

		observer.observe(detail);
		
		this.$addEvents(trigger, "click enter", (e) => {
			if (!e.target.matches("a")) {
				if (cell.classList.value.includes("leadership__grid-cell--active")) {
					cell.classList.remove("leadership__grid-cell--active");
					grid.classList.remove("leadership__grid--active");
				} else {
					cellArr.forEach(item => {
						if (item.classList.value.includes("leadership__grid-cell--active")) {
							item.classList.remove("leadership__grid-cell--active");
						}
					});
					cell.classList.add("leadership__grid-cell--active");
					grid.classList.add("leadership__grid--active");
					if (parseFloat(detail.getAttribute('data-visible')) < 0.7) {
						let rect = detail.getBoundingClientRect();
						window.scrollBy({
							top: (rect.bottom - window.innerHeight) + 32,
							behavior: 'smooth'
						});
					}
				}
			}
		});

		this.$addEvents(closeBtn, "click.prevent enter.prevent", () => {
			cell.classList.remove("leadership__grid-cell--active");
			grid.classList.remove("leadership__grid--active");
		});
	}
});